<template>
  <div style="margin: 10px; height: 600px">
    <v-form direction="horizontal">
      <div style="text-align: left">
        <v-affix :offset-top="10">
          <v-button type="success" icon="save" @click.prevent="save()"
            >保存</v-button
          >
        </v-affix>
      </div>
      <v-form-item
        label="起始日期"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-date-picker
          style="width: 100%"
          v-model="options.qsrq"
          clearable
          size="lg"
          format="yyyy-MM-dd"
        ></v-date-picker>
      </v-form-item>
      <v-form-item
        label="截至日期"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-date-picker
          style="width: 100%"
          v-model="options.jzrq"
          clearable
          size="lg"
          format="yyyy-MM-dd"
        ></v-date-picker>
      </v-form-item>
      <v-form-item
        label="总天数"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-input v-model="options.zs" placeholder="总天数"></v-input>
      </v-form-item>
    </v-form>
  </div>
</template>

<script>
let options = {
  id:"",
  qsrq: "",
  jzrq: "",
  zs: "",
};
export default {
  data() {
    return {
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      options
    };
  },
  created() {
    if (this.$route.query.id) {
      this.options.id = this.$route.query.id;
      this.init();
    }
  },
  methods: {
    init: function () {
      this.$axios
        .get("api/system/ryjqwh/get-ryjqwh-first?id=" + this.$route.query.id)
        .then((res) => {
          this.options = res.data;
        });
    },
    save() {
      if(!this.options.qsrq){
        this.$message["error"]("请选择起始日期！");
            return;
      }
      if(!this.options.jzrq){
        this.$message["error"]("请选择截止日期！");
            return;
      }
      if(this.options.qsrq > this.options.jzrq){
        this.$message["error"]("起始时间不能大于截止时间！");
            return;
      }
      var s1 = new Date(this.options.qsrq.replace(/-/g, "/"));
      var s2 = new Date(this.options.jzrq.replace(/-/g, "/"));
      var days = s2.getTime() - s1.getTime();
      var day = parseInt(days / (1000 * 60 * 60 * 24));
      if(this.options.zs > day){
        this.$message["error"]("总天数过大请重新输入！");
            return;
      }
      if (this.$route.query.id) {
        this.$axios
          .post("api/system/ryjqwh/update-ryjqwh-first", this.options)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message["success"](res.data.message);
              xadmin.close();
              xadmin.father_reload();
            } else {
              this.$message["error"](res.data.message);
            }
          });
      }
    },
    cancel: function () {
      xadmin.close();
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/jcsj/ryjqwhadd.vue